module.exports = __webpack_public_path__ + "img/clock.f91af43c.svg";